import styled from 'styled-components';

export const GraphWrapper = styled.div`
  flex: ${({ flex }) => flex};
  width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 250px;
`;

export const SimpleGraphWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const GraphTitle = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 14px;
  margin-bottom: ${({ theme }) => `${theme.metrics.smallMargin}px`};
`;

export const GraphContent = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: row;
`;

export const ErrorMessageWrapper = styled.span`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;



// WEBPACK FOOTER //
// ./src/common/modules/printing/styles/Graph.js